export default __webpack_public_path__ + "static/media/ic_circle_close.8497d093.svg";